import { render, staticRenderFns } from "./plx.vue?vue&type=template&id=2c3c0d08&scoped=true"
import script from "./plx.vue?vue&type=script&lang=js"
export * from "./plx.vue?vue&type=script&lang=js"
import style0 from "./plx.vue?vue&type=style&index=0&id=2c3c0d08&prod&lang=css"
import style1 from "./plx.vue?vue&type=style&index=1&id=2c3c0d08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3c0d08",
  null
  
)

export default component.exports